import * as ActionTypes from './../constants';
import axios from 'axios'; 
import {baseUrl,getUserToken } from './index'; 



const dispatchRequestBookMarks = testId => ({
    type:ActionTypes.REQUEST_BOOK_MARKS,
    testId
})

const dispatchReceivedBookMarks = res =>({
    type:ActionTypes.RECEIVED_BOOK_MARKS,
    res
})

const dispatchErrorBookMarks = (err) => ({
    type:ActionTypes.ERROR_BOOK_MARKS,
    err
})

const dispatchClearBookMarks= () => ({
    type: ActionTypes.CLEAR_BOOK_MARKS
})

export const clearBookMarksData = () => dispatchClearBookMarks();

export const getBookMarks = () => dispatch => {
   
    dispatch(dispatchRequestBookMarks());

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'post',           
                url: `${baseUrl}/api/myBookmarks`,                      
                headers: {
                    'Authorization': `Bearer ${authKey}`
                }
            }          
            return axios(options)
                .then(({data}) => {
                    dispatch(dispatchReceivedBookMarks(data))
                })
        })
        .catch(e => dispatch(dispatchErrorBookMarks(e.response)));    
}


// add book mark

const dispatchRequestAddBookMark = data => ({
    type:ActionTypes.REQUEST_ADD_BOOK_MARK,
    data
})

const dispatchReceivedAddBookMark = res =>({
    type:ActionTypes.RECEIVED_ADD_BOOK_MARK,
    res
})

const dispatchErrorAddBookMark = (err) => ({
    type:ActionTypes.ERROR_ADD_BOOK_MARK,
    err
})

const dispatchClearAddBookMark= () => ({
    type: ActionTypes.CLEAR_ADD_BOOK_MARK,
})

export const clearAddBookMarkData = () => dispatchClearAddBookMark();

export const addBookMark = (data) => dispatch => {

    const _data = {
        content_id: 1,
        content_name: 'name',
        content_url: 'url',
        screen_name: 'name',
        type: 'type',
        image_url: 'url',
        description: 'description'
    }

dispatch(dispatchRequestAddBookMark());

getUserToken()
    .then( authKey => {
        const options = {
            method: 'post',           
            url: `${baseUrl}/api/addMyBookmark`,
            data,          
            headers: {
                'Authorization': `Bearer ${authKey}`
            }
        }          
        return axios(options)
            .then(({data}) => {
                dispatch(dispatchReceivedAddBookMark(data))
            })
    })
    .catch(e => dispatch(dispatchErrorAddBookMark(e.response)));    
}


// delete book mark

const dispatchRequestDeleteBookMark = data => ({
    type:ActionTypes.REQUEST_DELETE_BOOK_MARK,
    data
})

const dispatchReceivedDeleteBookMark = res =>({
    type:ActionTypes.RECEIVED_DELETE_BOOK_MARK,
    res
})

const dispatchErrorDeleteBookMark = (err) => ({
    type:ActionTypes.ERROR_DELETE_BOOK_MARK,
    err
})

const dispatchClearDeleteBookMark= () => ({
    type: ActionTypes.CLEAR_DELETE_BOOK_MARK,
})

export const clearDeleteBookMarkData = () => dispatchClearDeleteBookMark();

export const deleteBookMark = (id) => dispatch => {

dispatch(dispatchRequestDeleteBookMark());

getUserToken()
    .then( authKey => {
        const options = {
            method: 'post',           
            url: `${baseUrl}/api/deleteMyBookmark`,
            data: {
                id
            },           
            headers: {
                'Authorization': `Bearer ${authKey}`
            }
        }          
        return axios(options)
            .then(({data}) => {
                dispatch(dispatchReceivedDeleteBookMark(data))
                dispatch(getBookMarks())
            })
    })
    .catch(e => dispatch(dispatchErrorDeleteBookMark(e.response)));    
}